// 由于淘宝采取的全表单动态渲染，有些复杂的表单控件层级也许会很深
// 且有可能控件间需要互相影响
// 所以将淘宝的表单数据采用vuex来管理
import { formatDataForm } from '@/components/prod/center/components/TBInfoForm/utils/data'

const tbForm = {
  state: () => ({
    form: {
      categoryIds: []
    }, // 当前淘宝表单
    oriData: {}, // 原数据，detail接口返回的数据
    // 目前后端对一些选项的接口未提供搜索分页功能，
    // 采取前端搜索分页
    optionsMap: {},
    secondaryUIType: {}, // 次级属性的控件type索引
    isNew: false, // 是否是新版表单
  }),
  mutations: {
    setTbIsNew(state, bool) {
      state.isNew = bool
    },
    updateSecondaryUIType(state, newUIType) {
      state.secondaryUIType = {
        ...state.secondaryUIType,
        ...newUIType
      }
    },
    // 更新form
    updateForm(state, newFormFields) {
      const updateFormFields = { ...newFormFields }
      Object.keys(updateFormFields).forEach(key => {
        // 对于name字段中含有.的进行替换为_____（5个下划线），不然在el-form-item中prop属性时会报错
        if(/\./.test(key)) {
          updateFormFields[key.replaceAll('.', '_____')] = updateFormFields[key]
        }
      })
      state.form = {
        ...state.form,
        ...updateFormFields
      }
    },
    clearFormSome(state, names) {
      let _form = {
        ...state.form
      }
      names.forEach(key => {
        delete _form[key]
      })
      state.form = _form
    },
    setForm(state, newForm) {
      state.form = {
        ...newForm,
      }
    },
    setOriData(state, data) {
      state.oriData = data
    },
    clear(state) {
      state.form = {
        categoryIds: []
      }
      state.oriData = {}
      state.optionsMap = {}
      state.secondaryUIType = {}
    },
    initOptions(state, {key, options}) {
      state.optionsMap[key] = options
    }
  },
  actions: {
    updateTbIsNew({commit}, data) {
      commit('setTbIsNew', data)
    },
    initTbData ({commit, dispatch, state}, {data, formSections}) {
      // 对data进行转换更新到form
      let form = formatDataForm(data, formSections)
      if (state.form.categoryIds.length) {
        delete form.categoryIds
      }
      dispatch("updateTbForm", form)
    },
    initTbOriData({commit, dispatch, state}, data) {
      commit("setOriData", data)
    },
    initTbSecondary ({dispatch, state}, formSections) {
      let _form = formatDataForm({...state.oriData}, formSections)
      dispatch("updateTbForm", _form)
    },
    initTbForm ({commit}, form) {
      commit("setForm", form)
    },
    updateTbForm ({commit}, newFormFields) {
      commit("updateForm", newFormFields)
    },
    updateTbSecondaryUIType ({commit}, newUIType) {
      commit("updateSecondaryUIType", newUIType)
    },
    clearTbFormSome ({commit}, names) {
      commit("clearFormSome", names)
    },
    clearTbForm_PData ({commit, state}) {
      // 清空所有p-的数据
      const voidObj = {}
      Object.keys(state.form).forEach(element => {
        if (/^p-/.test(element) && !/-sizeGroup$/.test(element)) {
          if (state.form[element] && !state.form[element][0].valueId) {
            // 输入框的类型
            voidObj[element] = JSON.parse(JSON.stringify(state.form[element]))
            voidObj[element][0].valueName = ""
            return ;
          }
          voidObj[element] = ''
        }
      });
      commit("updateForm", voidObj)
    },
    clearTbInfo({commit}) {
      commit("clear")
    },
    initTbOptions({commit}, data) {
      commit("initOptions", data)
    }
  },
  getters: {
    tbIsNew(state) {
      return state.isNew
    },
    tbForm(state) {
      return state.form
    },
    tbData(state) {
      return state.oriData
    },
    tbOptions: (state) => ({key, search}) => {
      if (!state.optionsMap[key]) return false
      return state.optionsMap[key].filter(op => op.displayName.indexOf(search) > -1).slice(0,99)
    },
    tbFindOption: (state) => ({key, value}) => {
      if (!state.optionsMap[key]) return false
      return state.optionsMap[key].find(op => op.value == value)
    }
  }
}

export default tbForm
